import CredentialsEducationPage from './CredentialsEducation.page';

export default CredentialsEducationPage;
